// src/data/products.js
export const products = [
  // ── T-SHIRTS ──────────────────────────────────
  {
    id: 1, name: "Superman Oversized T-Shirt",
    brand: "DC x TSS", category: "oversized-tshirts",
    price: 799, mrp: 999,
    img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&q=90",
    badge: "BESTSELLER", sizes: ["S","M","L","XL","XXL","3XL"],
    colors: ["#0a2e5e","#fff","#c0392b"], rating: 4.7, reviews: 5120,
    desc: "Bio-washed 100% cotton oversized tee featuring Superman chest emblem. Drop shoulders, relaxed fit.",
    tags: ["oversized", "dc", "licensed"], fit: "Oversized", fabric: "100% Bio-washed Cotton",
  },
  {
    id: 2, name: "TSS Culture Code Graphic Tee",
    brand: "TSS Originals", category: "tshirts",
    price: 699, mrp: 899,
    img: "https://images.unsplash.com/photo-1503341455253-b2e723bb3dbb?w=600&q=90",
    badge: "NEW", sizes: ["XS","S","M","L","XL","XXL"],
    colors: ["#1a1a1a","#4a9e8a","#c0392b"], rating: 4.4, reviews: 2340,
    desc: "Original TSS Culture Code graphic tee. Street art meets pop culture.",
    tags: ["graphic", "originals"], fit: "Regular", fabric: "100% Cotton",
  },
  {
    id: 3, name: "Marvel Avengers Tee",
    brand: "Marvel x TSS", category: "tshirts",
    price: 799, mrp: 1099,
    img: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=600&q=90",
    badge: "LICENSED", sizes: ["XS","S","M","L","XL","XXL","3XL","4XL","5XL"],
    colors: ["#c0392b","#1a1a1a","#fff"], rating: 4.8, reviews: 7830,
    desc: "Official Marvel Avengers licensed tee. All heroes, one tee.",
    tags: ["marvel", "licensed", "avengers"], fit: "Regular", fabric: "Bio-washed Cotton",
  },
  {
    id: 4, name: "Naruto Shippuden Oversized Tee",
    brand: "Naruto x TSS", category: "oversized-tshirts",
    price: 849, mrp: 1099,
    img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=600&q=90",
    badge: "HOT", sizes: ["S","M","L","XL","XXL","3XL"],
    colors: ["#e67e22","#1a1a1a","#f39c12"], rating: 4.9, reviews: 9210,
    desc: "Official Naruto Shippuden oversized tee. Perfect for anime fans.",
    tags: ["anime", "naruto", "licensed", "oversized"], fit: "Oversized", fabric: "Premium Cotton",
  },
  // ── SHIRTS ──────────────────────────────────
  {
    id: 5, name: "Linen Blend Casual Shirt",
    brand: "TSS Essentials", category: "shirts",
    price: 999, mrp: 1299,
    img: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=600&q=90",
    badge: "LINEN BLEND", sizes: ["S","M","L","XL","XXL"],
    colors: ["#c8b89a","#4a9e8a","#1a1a1a","#e8d5c4"], rating: 4.5, reviews: 1870,
    desc: "Premium linen blend shirt. Perfect for summer days. Relaxed comfortable fit.",
    tags: ["linen", "casual", "summer"], fit: "Relaxed", fabric: "Linen Blend",
  },
  {
    id: 6, name: "Check Flannel Shirt",
    brand: "TSS Co.", category: "shirts",
    price: 1099, mrp: 1499,
    img: "https://images.unsplash.com/photo-1594938298603-c8148c4b1dac?w=600&q=90",
    badge: "TEXTURED", sizes: ["S","M","L","XL","XXL"],
    colors: ["#264653","#c0392b","#8e6b45"], rating: 4.3, reviews: 1430,
    desc: "Classic flannel check shirt with textured fabric. Winter essential.",
    tags: ["flannel", "check", "casual"], fit: "Regular", fabric: "Flannel",
  },
  {
    id: 7, name: "Stretchable Oversized Shirt",
    brand: "TSS Flex", category: "shirts",
    price: 1199, mrp: 1599,
    img: "https://images.unsplash.com/photo-1578587018452-892bacefd3f2?w=600&q=90",
    badge: "STRETCHABLE", sizes: ["S","M","L","XL","XXL","3XL"],
    colors: ["#fff","#e8d5b7","#4a9e8a"], rating: 4.6, reviews: 2010,
    desc: "4-way stretch oversized shirt. Freedom of movement meets style.",
    tags: ["oversized", "stretch", "casual"], fit: "Oversized", fabric: "Stretch Cotton",
  },
  // ── HOODIES ──────────────────────────────────
  {
    id: 8, name: "Zip-Up Hoodie – Charcoal",
    brand: "TSS Cozy", category: "hoodies",
    price: 1099, mrp: 1499,
    img: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=600&q=90",
    badge: "HOT", sizes: ["S","M","L","XL","XXL"],
    colors: ["#34495e","#1a1a1a","#7f8c8d"], rating: 4.7, reviews: 4560,
    desc: "Classic zip-up hoodie in premium fleece. Warm, cozy, and stylish.",
    tags: ["hoodie", "zip", "winter"], fit: "Regular", fabric: "Cotton Fleece",
  },
  {
    id: 9, name: "Pullover Sweatshirt",
    brand: "TSS Cozy", category: "hoodies",
    price: 899, mrp: 1199,
    img: "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=600&q=90",
    badge: "", sizes: ["S","M","L","XL","XXL","3XL"],
    colors: ["#8e9eab","#c0a580","#2c3e50","#27ae60"], rating: 4.4, reviews: 2870,
    desc: "Everyday pullover sweatshirt. Comfortable French terry fabric.",
    tags: ["sweatshirt", "pullover"], fit: "Regular", fabric: "French Terry",
  },
  // ── JOGGERS ──────────────────────────────────
  {
    id: 10, name: "Cargo Jogger Pants",
    brand: "TSS Active", category: "joggers",
    price: 1199, mrp: 1599,
    img: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=600&q=90",
    badge: "TRENDING", sizes: ["S","M","L","XL","XXL","3XL"],
    colors: ["#1a1a1a","#8B4513","#2c3e50","#4a9e8a"], rating: 4.6, reviews: 3120,
    desc: "Relaxed cargo joggers with multiple pockets. Style meets utility.",
    tags: ["cargo", "jogger", "casual"], fit: "Relaxed", fabric: "Cotton Blend",
  },
  {
    id: 11, name: "Solids Faded Korean Joggers",
    brand: "TSS Essentials", category: "joggers",
    price: 899, mrp: 1199,
    img: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=600&q=90",
    badge: "NEW", sizes: ["S","M","L","XL","XXL"],
    colors: ["#c8b89a","#1a1a1a","#264653","#c0392b"], rating: 4.3, reviews: 1450,
    desc: "Acid-washed Korean style joggers. Faded aesthetic, premium feel.",
    tags: ["korean", "faded", "jogger"], fit: "Slim", fabric: "Cotton",
  },
  // ── POLOS ──────────────────────────────────
  {
    id: 12, name: "Solid Polo T-Shirt",
    brand: "TSS Classics", category: "polos",
    price: 1099, mrp: 1299,
    img: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10?w=600&q=90",
    badge: "", sizes: ["XS","S","M","L","XL","XXL"],
    colors: ["#1a4c7c","#1a1a1a","#fff","#27ae60","#c0392b"], rating: 4.3, reviews: 1540,
    desc: "Classic polo tee with ribbed collar and cuffs. Office to casual.",
    tags: ["polo", "classic", "formal-casual"], fit: "Regular", fabric: "Interlock Cotton",
  },
  // ── JEANS ──────────────────────────────────
  {
    id: 13, name: "Slim Fit Stretch Jeans",
    brand: "TSS Denim", category: "jeans",
    price: 1299, mrp: 1799,
    img: "https://images.unsplash.com/photo-1582552938357-32b906df40cb?w=600&q=90",
    badge: "PREMIUM", sizes: ["28","30","32","34","36","38"],
    colors: ["#1a2d5a","#1a1a1a","#4a6fa5"], rating: 4.5, reviews: 2200,
    desc: "Slim fit stretch denim jeans. All-day comfort with a sharp look.",
    tags: ["jeans", "denim", "slim"], fit: "Slim", fabric: "Stretch Denim",
  },
  // ── JACKETS ──────────────────────────────────
  {
    id: 14, name: "Denim Jacket",
    brand: "TSS Denim", category: "jackets",
    price: 1999, mrp: 2599,
    img: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=600&q=90",
    badge: "PREMIUM", sizes: ["S","M","L","XL","XXL"],
    colors: ["#4a6fa5","#1a1a1a"], rating: 4.6, reviews: 1120,
    desc: "Classic indigo denim jacket. Washed finish, timeless silhouette.",
    tags: ["jacket", "denim", "outerwear"], fit: "Regular", fabric: "100% Denim",
  },
  // ── COLLECTIBLES ──────────────────────────────────
  {
    id: 15, name: "Harry Potter: Gryffindor Collectible",
    brand: "HP x TSS", category: "collectibles",
    price: 1099, mrp: 1199,
    img: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=600&q=90",
    badge: "LICENSED", sizes: ["One Size"],
    colors: ["#c0392b","#f39c12"], rating: 4.8, reviews: 3400,
    desc: "Official Harry Potter Gryffindor alumni collectible. Fan essential.",
    tags: ["hp", "collectible", "licensed"], fit: "N/A", fabric: "N/A",
  },
  {
    id: 16, name: "Lord Voldemort's Wand Replica",
    brand: "HP x TSS", category: "collectibles",
    price: 1399, mrp: 1499,
    img: "https://images.unsplash.com/photo-1568667256549-094345857637?w=600&q=90",
    badge: "LICENSED", sizes: ["One Size"],
    colors: ["#1a1a1a"], rating: 4.9, reviews: 1890,
    desc: "Official replica of Lord Voldemort's wand. Detailed craftsmanship.",
    tags: ["hp", "wand", "collectible", "licensed"], fit: "N/A", fabric: "N/A",
  },
];

export const categories = [
  { id: "all", label: "Trending", icon: "🔥" },
  { id: "oversized-tshirts", label: "Oversized T-Shirts", icon: "👕" },
  { id: "tshirts", label: "T-Shirts", icon: "🎽" },
  { id: "shirts", label: "Shirts", icon: "👔" },
  { id: "hoodies", label: "Hoodies", icon: "🧥" },
  { id: "joggers", label: "Men Joggers", icon: "👖" },
  { id: "polos", label: "Polos", icon: "⭐" },
  { id: "jeans", label: "Men Jeans", icon: "👖" },
  { id: "jackets", label: "Jackets", icon: "🧣" },
  { id: "collectibles", label: "Collectibles", icon: "🏆" },
];

export const bannerImages = [
  {
    id: 1, title: "EXPLORE T-SHIRTS",
    subtitle: "Summer '26 Collection",
    mainImg: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&q=90",
    sideImg1: "https://images.unsplash.com/photo-1503341455253-b2e723bb3dbb?w=500&q=90",
    sideImg2: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=500&q=90",
    tag: "OVERSIZED · RELAXED", accentColor: "#d4f542",
  },
  {
    id: 2, title: "SUMMER '26",
    subtitle: "New Season Arrivals",
    mainImg: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=800&q=90",
    sideImg1: "https://images.unsplash.com/photo-1594938298603-c8148c4b1dac?w=500&q=90",
    sideImg2: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=500&q=90",
    tag: "FRESH DROPS", accentColor: "#42c8f5",
  },
  {
    id: 3, title: "LICENSED MERCH",
    subtitle: "200+ Official Licences",
    mainImg: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800&q=90",
    sideImg1: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=500&q=90",
    sideImg2: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=500&q=90",
    tag: "MARVEL · DC · ANIME", accentColor: "#f5a742",
  },
];

export const collectionBanners = [
  { id: 1, label: "Hot Merch", img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=300&q=80" },
  { id: 2, label: "Slides 2.0", img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&q=80" },
  { id: 3, label: "Culture Code", img: "https://images.unsplash.com/photo-1503341455253-b2e723bb3dbb?w=300&q=80" },
  { id: 4, label: "Marvel", img: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=300&q=80" },
  { id: 5, label: "Harry Potter", img: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&q=80" },
  { id: 6, label: "Summer Shirts", img: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=300&q=80" },
  { id: 7, label: "T-shirts", img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=300&q=80" },
  { id: 8, label: "Cotton Linen", img: "https://images.unsplash.com/photo-1594938298603-c8148c4b1dac?w=300&q=80" },
  { id: 9, label: "Polos", img: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10?w=300&q=80" },
  { id: 10, label: "Joggers", img: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=300&q=80" },
];
